import type { ReactElement } from 'react';
import styles from './InstructionVideoEmbed.module.scss';

type Props = {
  title: string;
  embedUrl: string;
};

export default function InstructionVideoEmbed(props: Props): ReactElement {
  return (
    <div className={styles.container}>
      <h3 className={styles.heading}>{props.title}</h3>
      <div className={styles.frameResizer}>
        <div className={styles.frame}>
          <iframe src={props.embedUrl} frameBorder="0" allowFullScreen />
        </div>
      </div>
    </div>
  );
}
